module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/img-chapel-course-2a261598aec3921fb6885237b66f43c1.png";